"use client";

import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import QRCode from "qrcode";
import { WEB_BASE_URL } from "../../../../config";
import { useNetwork } from "../../../Team/hooks/use-network";

interface ReferralActionsProps {
  referralCode: string;
}

export const ReferralActions: React.FC<ReferralActionsProps> = ({ referralCode }) => {
  const { copyReferralLink, shareViaWhatsApp, shareViaEmail } = useNetwork();

  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState<string>("");

  const generateQRCode = async () => {
    try {
      const referralLink = `${WEB_BASE_URL}/sign-up?code=${referralCode}`;
      const qrCodeDataURL = await QRCode.toDataURL(referralLink, {
        width: 256,
        margin: 2,
        color: {
          dark: "#000000",
          light: "#FFFFFF",
        },
      });
      setQrCodeUrl(qrCodeDataURL);
      setQrModalOpen(true);
    } catch (error) {
      console.error("Error generating QR code:", error);
      alert("Error al generar el código QR");
    }
  };

  const downloadQRCode = () => {
    if (!qrCodeUrl) return;
    const link = document.createElement("a");
    link.download = `qr-code-${referralCode}.png`;
    link.href = qrCodeUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {/* Botones */}
      <div>
        <div className="d-flex gap-2">
          <Button
            className="btn btn-sm btn-outline-primary"
            onClick={copyReferralLink}
            title="Copiar enlace"
          >
            <i className="ri-file-copy-line"></i>
          </Button>
          <Button
            className="btn btn-sm btn-outline-primary"
            onClick={shareViaWhatsApp}
            title="Compartir por WhatsApp"
          >
            <i className="ri-whatsapp-line"></i>
          </Button>
          <Button
            className="btn btn-sm btn-outline-primary"
            onClick={shareViaEmail}
            title="Compartir por Email"
          >
            <i className="ri-mail-line"></i>
          </Button>
          <Button
            className="btn btn-sm btn-outline-primary"
            onClick={generateQRCode}
            title="Generar código QR"
          >
            <i className="ri-qr-code-line"></i>
          </Button>
        </div>
      </div>

      {/* Modal */}
      <Modal show={qrModalOpen} onHide={() => setQrModalOpen(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Código QR de Referido</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div className="mb-3">
              <h6>Código: {referralCode}</h6>
              <small className="text-muted">
                Escanea este código QR para registrarse con tu código de referido
              </small>
            </div>
            {qrCodeUrl && (
              <div className="mb-3">
                <img
                  src={qrCodeUrl}
                  alt="QR Code"
                  className="img-fluid"
                  style={{
                    maxWidth: "256px",
                    border: "1px solid #dee2e6",
                    borderRadius: "8px",
                  }}
                />
              </div>
            )}
            <div className="d-flex justify-content-center gap-2">
              <Button
                variant="primary"
                onClick={downloadQRCode}
                disabled={!qrCodeUrl}
              >
                <i className="ri-download-line me-1"></i>
                Descargar QR
              </Button>
              <Button variant="outline-secondary" onClick={copyReferralLink}>
                <i className="ri-file-copy-line me-1"></i>
                Copiar Enlace
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
